import { DetailsDisclosure } from '@/scripts/theme/details-disclosure';
import { TsDOM as q } from '@/scripts/core/TsDOM'
import {
  scaleValue,
} from '@/scripts/core/global'
import {type StickyHeader } from '@/scripts/theme/sticky-header';
import { SELECTORS } from '@/scripts/core/global';

export class HeaderMenu extends DetailsDisclosure {
  static override htmlSelector = 'header-menu'
  header: StickyHeader | null
  hoverSummary?: HTMLElement
  detailsId?: string
  constructor() {
    super()
    this.header = q.rs<StickyHeader>(SELECTORS.headerWrapper)
    this.hoverSummary = q.os('summary[data-summary-hover="on"]', this)
    this.detailsId = q.oa(this.mainDetailsToggle, 'id')
    this.initHoverSummary()
  }

  initHoverSummary() {
    if (!this.hoverSummary || !this.detailsId) return

    this.hoverSummary.addEventListener('click', (_) => {
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      window.setTimeout(() => {
        void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      }, 3)
    })

    this.hoverSummary.addEventListener('mouseenter', (_) => {
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)

      // Close any previously open menu that isn't this one
      const openMenuId = window.Ucoast.openMenuId
      if (openMenuId && openMenuId !== this.detailsId) {
        const previousMenu = document.getElementById(openMenuId)
        if (previousMenu) {
          previousMenu.removeAttribute('open')
          const previousSummary = previousMenu.querySelector('summary')
          if (previousSummary) previousSummary.setAttribute('aria-expanded', 'false')
        }
      }

      // Only proceed if menu isn't already open
      if (openMenuId && openMenuId === this.detailsId) return

      window.Ucoast.openMenuId = this.detailsId

      // Get animation configuration
      const headerWrapper = document.querySelector('[data-uc-header-wrapper]');

      // Check if animation should be applied:
      // 1. Ensure it's enabled in theme settings
      // 2. Respect user's reduced motion preference
      const isAnimationEnabled = headerWrapper?.hasAttribute('data-menu-animation');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Apply animation only if all conditions are met
      if (isAnimationEnabled && !prefersReducedMotion) {
        const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
        if (content) {
          try {
            // Use requestAnimationFrame for better performance
            requestAnimationFrame(() => {
              // Set initial state
              content.style.transition = 'none';
              content.style.transform = 'translateY(-15px)';

              // Minimal forced reflow - necessary evil for the animation to work properly
              void content.offsetWidth;

              // Set up animation with requestAnimationFrame for better performance
              requestAnimationFrame(() => {
                content.style.transition = 'transform 0.25s ease-out';
                content.style.transform = '';
              });
            });
          } catch (e) {
            // Fallback in case of error - ensure the menu still opens
            console.error('Menu animation error:', e);
          }
        }
      }

      // Always ensure menu opens, regardless of animation status
      this.mainDetailsToggle.setAttribute('open', '');
      this.animations?.forEach((animation) => animation.play());
      this.hoverSummary?.setAttribute('aria-expanded', 'true');
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle);
    })

    this.mainDetailsToggle.addEventListener('keyup', q.onKeyUpEscape)
  }

  override onToggle() {
    if (!this.header) return
    this.header.preventHide = this.mainDetailsToggle.open

    if (
      document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !==
      ''
    )
      return
    const viewport = window.innerWidth >= 750 ? 'desktop' : 'mobile'
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `calc(${scaleValue(this.header.getBoundingClientRect().bottom, viewport)} * var(--ax))`
    )
  }
}
